import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/settings`
const DOC_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

export const urlUsers = `${BASE_URL}/users`
export const urlUsersDeactivate = tp_id => `${BASE_URL}/users/deactivate/${tp_id}`
export const urlUsersClone = tp_id => `${BASE_URL}/users/clone`
export const urlUsersByTp = tp_id => `${BASE_URL}/users/${tp_id}`
export const urlUserToggleActived = userId => `${BASE_URL}/user-toggle-actived/${userId}`
export const urlUserToggleActivedTpAdmin = (userId, tpId, adminId) =>
  `${BASE_URL}/user-toggle-actived-TpAdmin/${userId}/${tpId}/${adminId}`
export const urlEditUser = userId => `${BASE_URL}/edit-user/${userId}`
export const urlEditUserTpAdmin = (userId, tpId, adminId) =>
  `${BASE_URL}/edit-user-TpAdmin/${userId}/${tpId}/${adminId}`
export const urlRegisterUser = `${BASE_URL}/register-user`
export const urlLoginUser = `${BASE_URL}/login-user`
export const urlLoginMfaVerify = `${BASE_URL}/login-mfa/verify`
export const urlLoginMfaResend = `${BASE_URL}/login-mfa/resend`

// Operadores Logísticos TPs
export const urlTps = `${BASE_URL}/tps`
export const urlTpsPaginados = params =>
  `${BASE_URL}/tps?${Object.entries(params)
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')}`
export const urlTp = `${BASE_URL}/tp`
export const urlTpById = tp_id => `${BASE_URL}/tp/${tp_id}`
export const urlTpLogo = tp_id => `${DOC_BASE_URL}/logo-tp/${tp_id}`
export const urlTpLogoApi = tp_id => `${BASE_URL}/tp/logo/${tp_id}`
export const urlAssocTpEmpresas = `${BASE_URL}/associar-tp-empresas`
export const urlAssocTpPermissions = `${BASE_URL}/associar-tp-permissions`
export const urlAssocTpEmissores = `${BASE_URL}/associar-tp-emissores`
export const urlGenerateTokenRoboXml = tp_id => `${BASE_URL}/generate-token-robot/${tp_id}`
export const urlUsersActiveByTp = tp_id => `${BASE_URL}/users/actived/${tp_id}`
export const urlUsersAllByTp = (tp_id, userId) => `${BASE_URL}/users/all/${tp_id}/${userId}`

// Empresas
export const urlCompanies = `${BASE_URL}/companies`
export const urlCompany = `${BASE_URL}/company`
export const urlCompaniesUser = `${BASE_URL}/companies-user`

//Grupos
export const urlGroups = `${BASE_URL}/groups`
export const urlGroup = `${BASE_URL}/group`
// Usuários
export const urlUserTpByUserId = userId => `${BASE_URL}/user-tp/${userId}`
export const urlUserTp = `${BASE_URL}/user-tp`
export const urlUserGroupByUserId = userId => `${BASE_URL}/user-group/${userId}`
export const urlUserGroup = `${BASE_URL}/user-group`
export const urlUserCompanyByUserId = userId => `${BASE_URL}/user-company/${userId}`
export const urlUserCompany = `${BASE_URL}/user-company`
//Central de Operacoes
export const urlPostCentralOperacoes = `${BASE_URL}/operation-center`
export function urlPutCentralOperacoes(operacaoId) {
  return `${BASE_URL}/operation-center/${operacaoId}`
}
export const urlGetCentralOperacoes = `${BASE_URL}/operations-centers`
export function urlGetCentralOperacoesByUserId(userId) {
  return `${BASE_URL}/user-operation-center/${userId}`
}
export const urlPostUserOperationCenter = `${BASE_URL}/user-operation-center`

// Configurações do robô de leitura de XML
export const urlXmlRobotFtpServers = `${BASE_URL}/xml-robot/ftp-servers`
export const urlXmlRobotFtpServer = `${BASE_URL}/xml-robot/ftp-server`
export function urlXmlRobotFtpServerById(id) {
  return `${BASE_URL}/xml-robot/ftp-server/${id}`
}
export function urlXmlRobotFtpServerCompanies(id) {
  return `${BASE_URL}/xml-robot/ftp-server/${id}/companies`
}
export function urlXmlRobotFtpServerCompany(id) {
  return `${BASE_URL}/xml-robot/ftp-server/${id}/company`
}
export function urlDeleteXmlRobotFtpServerCompany(id) {
  return `${BASE_URL}/xml-robot/ftp-server/company/${id}`
}
export const urlXmlRobotActiveTps = `${BASE_URL}/xml-robot/active-tps`
export const urlXmlRobotActiveCompanies = `${BASE_URL}/xml-robot/active-companies`
export const urlXmlRobotFtpConfig = `${BASE_URL}/xml-robot/ftp-config`

// Configurações do robô de leitura de XML - Email
export const urlXmlRobotEmailReceivers = `${BASE_URL}/xml-robot/email-receivers`
export const urlXmlRobotEmailReceiver = `${BASE_URL}/xml-robot/email-receiver`
export function urlXmlRobotEmailReceiverById(id) {
  return `${BASE_URL}/xml-robot/email-receiver/${id}`
}
export function urlXmlRobotEmailReceiverSenders(id) {
  return `${BASE_URL}/xml-robot/email-receiver/${id}/senders`
}
export function urlXmlRobotEmailReceiverSender(id) {
  return `${BASE_URL}/xml-robot/email-receiver/${id}/sender`
}
export function urlDeleteXmlRobotEmailSender(id) {
  return `${BASE_URL}/xml-robot/email-sender/${id}`
}

// Logs de importação do robô de XML
export function urlXmlRobotImportLogs(pInicial, pFinal) {
  return `${BASE_URL}/xml-robot/import-logs?pInicial=${pInicial}&pFinal=${pFinal}`
}
export function urlXmlRobotImportLogFile(logId) {
  return `${BASE_URL}/xml-robot/import-logs/${logId}/file`
}

// Treinamentos
export const urlTreinamentos = `${BASE_URL}/treinamentos`
export function urlTreinamentoById(id) {
  return `${BASE_URL}/treinamento/${id}`
}
export const urlTreinamentoPost = `${BASE_URL}/treinamento`
export function urlTreinamentoPut(id) {
  return `${BASE_URL}/treinamento/${id}`
}
export function urlTreinamentoDelete(id) {
  return `${BASE_URL}/treinamento/${id}`
}
export function urlTreinamentoMateriais(treinamentoId) {
  return `${BASE_URL}/treinamento/${treinamentoId}/materiais`
}
export function urlTreinamentoMaterialPost(treinamentoId) {
  return `${BASE_URL}/treinamento/${treinamentoId}/material`
}
export function urlTreinamentoMaterialDelete(id) {
  return `${BASE_URL}/treinamento/material/${id}`
}
export const urlTreinamentosActiveTps = `${BASE_URL}/treinamentos/active-tps`
export const urlTreinamentosActiveCompanies = `${BASE_URL}/treinamentos/active-companies`
export function urlTreinamentoMaterialUpload(treinamentoId) {
  return `${DOC_BASE_URL}/material-apoio-treinamento/${treinamentoId}`
}
export function urlTreinamentoMaterialS3Delete(filename) {
  return `${DOC_BASE_URL}/material-apoio-treinamento/${filename}`
}
